import React from 'react'

import themeConfig from '@lib/themeConfig';


class Footer extends React.Component {
    render() {
        return (

            <footer>
                <div className='container-fluid'>
                    <div className='row text-muted'>
                        <div className='col-8 text-start'>
                            <ul className='list-inline'>
                                <li className='list-inline-item'>
                                    <a className='text-muted' href='#'>&nbsp;</a>
                                </li>
                                <li className='list-inline-item'>
                                    <a className='text-muted' href='#'>&nbsp;</a>
                                </li>
                                <li className='list-inline-item'>
                                    <a className='text-muted' href='#'>&nbsp;</a>
                                </li>
                                <li className='list-inline-item'>
                                    <a className='text-muted' href='#'>&nbsp;</a>
                                </li>
                            </ul>
                        </div>
                        <div className='col-4 text-end'>
                            <p className='mb-0'>
                                © 2025 - <a className='text-muted' href={`${themeConfig.app.appDeveloperUrl}`} target='_blank'>{`${themeConfig.app.appDeveloper}`}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>

        )
    }
}

export default Footer;